'use client'
import { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { ContactForm } from './contactFrom';
import { appConfig } from '@/_config';

const WHY_POINTS = [
    { icon: 'pi pi-bolt',     text: 'Fast response within 24 hours' },
    { icon: 'pi pi-shield',   text: '2-year product warranty' },
    { icon: 'pi pi-home',     text: 'Expert smart home setup support' },
    { icon: 'pi pi-verified', text: 'Certified IoT products' },
];

const REACH_US = [
    { icon: 'pi pi-phone',      text: appConfig.contacts.enquiry },
    { icon: 'pi pi-envelope',   text: appConfig.contacts.emailSupport },
    { icon: 'pi pi-map-marker', text: 'Greater Noida, Uttar Pradesh' },
];

const InfoPanel = ({ title }) => (
    <div style={{
        width: 270,
        flexShrink: 0,
        background: 'linear-gradient(160deg, #0a1f44 0%, #0c3264 60%, #0e4a5c 100%)',
        color: '#fff',
        padding: '2rem 1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.75rem',
        overflowY: 'auto',
    }}>
        {/* Brand name */}
        <div>
            <p style={{ margin: 0, fontSize: '2.2rem', fontWeight: 800, color: '#fff', letterSpacing: '0.06em' }}>
                ENNIX
            </p>
            <p style={{ fontSize: '0.7rem', color: '#00d2be', marginTop: 4, marginBottom: 0 }}>
                Designing Your Integrated Home
            </p>
        </div>

        {/* Heading */}
        <div>
            <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700, color: '#fff', lineHeight: 1.3 }}>
                Send Enquiry
            </h2>
            {title && (
                <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.55)', marginTop: 6, marginBottom: 0, lineHeight: 1.5 }}>
                    {title}
                </p>
            )}
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(255,255,255,0.1)' }} />

        {/* Why Ennix */}
        <div>
            <p style={{ margin: '0 0 0.85rem', fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#00d2be' }}>
                Why Ennix?
            </p>
            {WHY_POINTS.map(({ icon, text }) => (
                <div key={text} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 12 }}>
                    <div style={{
                        width: 28, height: 28, borderRadius: '50%',
                        background: 'rgba(0,210,190,0.13)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    }}>
                        <i className={icon} style={{ fontSize: '0.72rem', color: '#00d2be' }} />
                    </div>
                    <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.72)', lineHeight: 1.5, paddingTop: 4 }}>
                        {text}
                    </span>
                </div>
            ))}
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(255,255,255,0.1)' }} />

        {/* Reach us */}
        <div>
            <p style={{ margin: '0 0 0.85rem', fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#00d2be' }}>
                Reach Us
            </p>
            {REACH_US.map(({ icon, text }) => (
                <div key={text} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 12 }}>
                    <i className={icon} style={{ fontSize: '0.78rem', color: '#00d2be', paddingTop: 3, flexShrink: 0 }} />
                    <span style={{ fontSize: '0.79rem', color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>{text}</span>
                </div>
            ))}
        </div>

        {/* Spacer */}
        <div style={{ flex: 1 }} />

        {/* Office hours */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1.1rem' }}>
            <p style={{ margin: '0 0 0.4rem', fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#00d2be' }}>
                Office Hours
            </p>
            <p style={{ margin: 0, fontSize: '0.78rem', color: 'rgba(255,255,255,0.6)' }}>Mon – Sat: 9:00 AM – 6:00 PM</p>
        </div>
    </div>
);

export const EnquiryModal = ({ title, setVisible, visible, doClose }) => {
    const onHide = () => {
        if (doClose) return doClose();
        if (!visible) return;
        setVisible(false);
    };

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            position="right"
            style={{ width: 'min(860px, 100vw)', padding: 0 }}
            pt={{
                header:  { style: { display: 'none' } },
                content: { style: { padding: 0, display: 'flex', height: '100%', overflow: 'hidden' } },
            }}
        >
            <style>{`
                .enquiry-info-panel { display: flex; }
                @media (max-width: 640px) {
                    .enquiry-info-panel { display: none !important; }
                    .enquiry-form-panel { padding: 1.25rem 1rem !important; }
                }
            `}</style>

            <div style={{ display: 'flex', height: '100%', width: '100%', overflow: 'hidden' }}>

                {/* ── Left info panel (hidden on mobile) ── */}
                <div className="enquiry-info-panel" style={{ height: '100%' }}>
                    <InfoPanel title={title} />
                </div>

                {/* ── Right form panel ── */}
                <div className="enquiry-form-panel" style={{ flex: 1, overflowY: 'auto', padding: '2rem 1.75rem', background: '#fff', display: 'flex', flexDirection: 'column' }}>

                    {/* Form header */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: 700, color: 'var(--primary-color)' }}>
                                Get in Touch
                            </h3>
                            <p style={{ margin: '4px 0 0', fontSize: '0.82rem', color: '#64748b' }}>
                                Fill in the details and we'll get back to you shortly.
                            </p>
                        </div>
                        <button
                            onClick={onHide}
                            aria-label="Close"
                            style={{
                                background: 'none', border: '1px solid #e2e8f0', borderRadius: 8,
                                cursor: 'pointer', color: '#94a3b8', padding: '6px 8px',
                                display: 'flex', alignItems: 'center', transition: 'all 0.15s', flexShrink: 0,
                            }}
                            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary-color)'; e.currentTarget.style.color = 'var(--primary-color)'; }}
                            onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#94a3b8'; }}
                        >
                            <i className="pi pi-times" style={{ fontSize: '0.85rem' }} />
                        </button>
                    </div>

                    <ContactForm title={title} />
                </div>
            </div>
        </Sidebar>
    );
};

export const EnquiryPopup = ({ title, className }) => {
    const [isShow, setIsShow] = useState(false);

    return (
        <div>
            <EnquiryModal title={title} visible={isShow} setVisible={setIsShow} />
            <Button
                onClick={() => setIsShow(true)}
                label="Send Enquiry"
                size="small"
                icon="pi pi-envelope"
                className={classNames(className)}
                style={{
                    background: 'transparent',
                    border: '2px solid var(--primary-color)',
                    color: 'var(--primary-color)',
                    fontWeight: 700,
                }}
            />
        </div>
    );
};
